import { authApi } from 'api';
import { BusinessQuery } from 'api/shared';
import { User } from '../me/dtos';
import {
  BusinessInfo,
  BusinessSettings,
  UpdateBusinessRequest,
  UpdateSettingsRequest,
} from './dtos';

export const getBusinessInfo = async (data: BusinessQuery) => {
  return authApi.get<BusinessInfo>(data.businessId, '');
};

export const updateBusinessInfo = async (data: UpdateBusinessRequest) => {
  const { businessId, ...rest } = data;
  return authApi.put<BusinessInfo>(businessId, '', { body: rest });
};

export const getBusinessSettings = async (data: BusinessQuery) => {
  return authApi.get<BusinessSettings>(data.businessId, '/settings');
};

export const updateBusinessSettings = async (data: UpdateSettingsRequest) => {
  const { businessId, ...rest } = data;
  return authApi.put<BusinessSettings>(businessId, '/settings', { body: rest });
};

export const getBusinessPublicAccount = async (data: BusinessQuery) => {
  return authApi.get<User>(data.businessId, '/public-account');
};

export const uploadBusinessPolicy = async (businessId: number, data: FormData) => {
  return authApi.post(businessId, '/policy', { body: data });
};

export const uploadBusinessLogo = async (businessId: number, data: FormData) => {
  return authApi.post(businessId, '/logo', { body: data });
};

export const deleteBusinessLogo = async (businessId: number) => {
  return authApi.del(businessId, '/logo');
};

export const removeBusinessPolicy = async (businessId: number) => {
  return authApi.del(businessId, '/policy');
};
